if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const stockContainer = this.closest('[data-in-stock]');
      if (this.submitButton?.disabled || this.submitButton?.dataset.variantSoldOut === 'true' || stockContainer?.dataset.inStock === 'false' || this.closest('.outlet-out-of-stock')) return;
      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Check if CelebrationUpsellModal is present and active on this page
      const modal = document.getElementById('CelebrationUpsellModal');
      const formId = this.form ? this.form.getAttribute('id') : '';
      const qtyInput = (formId ? document.querySelector(`[name="quantity"][form="${formId}"]`) : null) || this.form.querySelector('[name="quantity"]') || document.querySelector('quantity-input input[name="quantity"]');
      const quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

      if (modal) {
        const variantIdInput = this.form.querySelector('[name="id"]');
        const variantId = variantIdInput ? variantIdInput.value : '';

        if (variantId) {
          window.upsellAction = 'cart';

          const properties = {};
          this.form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(input => {
            const match = input.name.match(/properties\[(.*?)\]/);
            if (match && input.value && input.value.trim() !== '') {
              properties[match[1]] = input.value.trim();
            }
          });

          const mainItem = { id: parseInt(variantId), quantity: parseInt(quantity) || 1 };
          if (Object.keys(properties).length > 0) {
            mainItem.properties = properties;
          }

          window.selectedItems = [mainItem];

          modal.querySelectorAll('.celebration-upsell-add-btn').forEach(btn => {
            btn.classList.remove('added');
            btn.textContent = 'Add';
            btn.disabled = false;
          });

          modal.classList.add('open');
          return;
        }
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Optimistically open the cart drawer immediately for instant feedback
      if (this.cart && this.dataset.cartType !== 'page') {
        this.cart.open();
        
        // Optimistically increment the header cart bubble count
        const bubbleSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble span[aria-hidden="true"]');
        let currentCount = 0;
        if (bubbleSpan) {
          currentCount = parseInt(bubbleSpan.textContent) || 0;
          window.updateCartBubbleCount(currentCount + quantity);
        } else {
          window.updateCartBubbleCount(quantity);
        }

        // Parse product details for optimistic drawer update
        const variantInput = this.form.querySelector('[name="id"]');
        const variantId = variantInput ? variantInput.value : '';
        const cardWrapper = this.closest('.card-wrapper') || this.closest('.card') || this.closest('.product');
        if (cardWrapper && variantId) {
          const titleEl = cardWrapper.querySelector('.card__heading a, .product__title');
          const title = titleEl ? titleEl.textContent.trim() : '';
          const imgEl = cardWrapper.querySelector('.card__media img, .product__media img');
          const imgUrl = imgEl ? imgEl.src : '';
          const priceEl = cardWrapper.querySelector('.price-item--regular, .price');
          const unitPriceCents = window.parseCartMoney && priceEl ? window.parseCartMoney(priceEl.textContent) : 0;

          // If drawer is already open and has a cart items table
          let tbody = this.cart.querySelector('#CartDrawer-CartItems tbody');
          if (!tbody) {
            const cartItemsContainer = this.cart.querySelector('#CartDrawer-CartItems');
            if (cartItemsContainer) {
              cartItemsContainer.innerHTML = `
                <div class="drawer__cart-items-wrapper">
                  <table class="cart-items" role="table">
                    <tbody role="rowgroup"></tbody>
                  </table>
                </div>
              `;
              tbody = cartItemsContainer.querySelector('tbody');
            }
          }

          if (tbody) {
            const existingRow = this.cart.querySelector(`.cart-item[data-variant-id="${variantId}"]`);
            if (existingRow) {
              const qtyInputEl = existingRow.querySelector('.quantity__input');
              if (qtyInputEl) {
                const oldQty = parseInt(qtyInputEl.value) || 0;
                const newQty = oldQty + quantity;
                qtyInputEl.value = newQty;
                qtyInputEl.dataset.oldValue = newQty;

                const finalPriceEl = existingRow.querySelector('.cart-item-final-price');
                if (finalPriceEl && typeof Shopify !== 'undefined' && typeof DT_THEME !== 'undefined') {
                  finalPriceEl.textContent = Shopify.formatMoney(unitPriceCents * newQty, DT_THEME.moneyFormat);
                }
              }
            } else {
              // Create temporary row inside drawer table
              const tempRow = document.createElement('tr');
              tempRow.className = 'cart-item temp-cart-item';
              tempRow.setAttribute('role', 'row');
              tempRow.dataset.variantId = variantId;
              tempRow.dataset.unitPrice = unitPriceCents;
              tempRow.innerHTML = `
                <td class="cart-item__media" role="cell">
                  <img class="cart-item__image" width="150" style="max-width: 70px; height: auto; border-radius: 8px;">
                </td>
                <td class="cart-item__details" role="cell" style="padding-left: 1.5rem;">
                  <span class="cart-item__name h4 break" style="display: block; font-weight: 500; margin-bottom: 0.5rem; font-size: 1.5rem; color: #56456f;"></span>
                  <div class="cart-item__totals right" role="cell">
                    <div class="cart-item__price-wrapper">
                      <span class="price price--end cart-item-final-price" style="font-weight: 600; color: #56456f;"></span>
                    </div>
                  </div>
                  <div class="cart-item__quantity" role="cell" style="margin-top: 0.5rem;">
                    <div class="cart-item__quantity-wrapper">
                      <div class="quantity" style="display: inline-flex; align-items: center; border: 1px solid rgba(var(--color-foreground), 0.2); border-radius: 4px; padding: 2px;">
                        <button class="quantity__button" name="minus" type="button" style="width: 26px; height: 26px; border: none; background: transparent; cursor: pointer;">−</button>
                        <input class="quantity__input" type="number" readonly style="width: 32px; text-align: center; border: none; background: transparent; font-size: 1.3rem; outline: none;">
                        <button class="quantity__button" name="plus" type="button" style="width: 26px; height: 26px; border: none; background: transparent; cursor: pointer;">+</button>
                      </div>
                    </div>
                  </div>
                </td>
              `;
              tempRow.querySelector('.cart-item__image').src = imgUrl;
              tempRow.querySelector('.cart-item__image').alt = title;
              tempRow.querySelector('.cart-item__name').textContent = title;
              tempRow.querySelector('.quantity__input').value = quantity;
              if (typeof Shopify !== 'undefined' && typeof DT_THEME !== 'undefined') {
                tempRow.querySelector('.cart-item-final-price').textContent = Shopify.formatMoney(unitPriceCents * quantity, DT_THEME.moneyFormat);
              }
              tbody.appendChild(tempRow);
            }

            // Update subtotal in drawer optimistically
            const drawerSubtotalEl = this.cart.querySelector('.totals__subtotal-value');
            if (drawerSubtotalEl && typeof Shopify !== 'undefined' && typeof DT_THEME !== 'undefined') {
              const currentSubtotalCents = window.getCartAmountCents(drawerSubtotalEl);
              window.setCartAmountCents(drawerSubtotalEl, currentSubtotalCents + (unitPriceCents * quantity));
              if (window.updateDeliveryPreview) window.updateDeliveryPreview(unitPriceCents * quantity);
            }
            
            // Remove empty class if present
            this.cart.classList.remove('is-empty');
            const drawerFooter = this.cart.querySelector('.drawer__footer');
            if (drawerFooter) drawerFooter.classList.remove('is-empty');
            const drawerColl = this.cart.querySelector('.cart-drawer__collection');
            if (drawerColl) drawerColl.classList.remove('is-empty');

            // Enable buttons
            const checkoutBtn = this.cart.querySelector('#CartDrawer-Checkout');
            if (checkoutBtn && checkoutBtn.dataset.feePending !== 'true') checkoutBtn.removeAttribute('disabled');
            const viewCartBtn = this.cart.querySelector('#CartDrawer-Cart');
            if (viewCartBtn) viewCartBtn.removeAttribute('disabled');
          }
        }
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Ensure variant ID input is enabled and captured in FormData
      let formIdInput = this.form.querySelector('[name="id"]') || this.closest('.card-wrapper, .card, .product, .product-form')?.querySelector('.variant-push, [name="id"]');
      if (formIdInput) {
        formIdInput.disabled = false;
        formIdInput.removeAttribute('disabled');
      }
      let variantId = formIdInput ? formIdInput.value : '';
      if (!variantId) {
        const checkedRadio = this.closest('.card-wrapper, .card, .product')?.querySelector('input[name="id"]:checked, input.variant-option:checked');
        if (checkedRadio) variantId = checkedRadio.value;
      }

      const formData = new FormData(this.form);
      formData.set('quantity', quantity);
      if (!formData.get('id') && variantId) {
        formData.set('id', variantId);
      }

      if (this.dataset.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description || response.message || 'Failed to add item to cart');

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            if (this.cart && typeof this.cart.syncCartDrawer === 'function') {
              this.cart.syncCartDrawer(true);
            }
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          if (this.cart && typeof this.cart.syncCartDrawer === 'function') {
            this.cart.syncCartDrawer(true);
          }
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).ajaxComplete(function() {
  if (typeof CartJS !== 'undefined') {
    CartJS.updateCart();
  }
});

// Celebration Upsell Modal Logic
function initCelebrationUpsell() {
  if (window.celebrationUpsellInitialized) return;
  window.celebrationUpsellInitialized = true;

  window.selectedItems = window.selectedItems || []; // Array of { id, quantity } added dynamically
  window.upsellAction = window.upsellAction || 'checkout'; // 'checkout' or 'cart'

  // Open modal when custom Buy Now button is clicked
  document.addEventListener('click', (e) => {
    const buyNowBtn = e.target.closest('.custom-buy-now-btn');
    if (!buyNowBtn) return;

    if (buyNowBtn.disabled || buyNowBtn.hasAttribute('disabled') || buyNowBtn.style.display === 'none' || getComputedStyle(buyNowBtn).display === 'none') {
      e.preventDefault();
      return;
    }

    const modal = document.getElementById('CelebrationUpsellModal');
    if (!modal) return;

    e.preventDefault();

    // Find the nearest form and variant ID
    const form = buyNowBtn.closest('form') || document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const properties = {};
    form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(input => {
      const match = input.name.match(/properties\[(.*?)\]/);
      if (match && input.value && input.value.trim() !== '') {
        properties[match[1]] = input.value.trim();
      }
    });

    const variantIdInput = form.querySelector('[name="id"]');
    const variantId = variantIdInput ? variantIdInput.value : '';
    const formId = form ? form.getAttribute('id') : '';
    const qtyInput = (formId ? document.querySelector(`[name="quantity"][form="${formId}"]`) : null) || form.querySelector('[name="quantity"]') || document.querySelector('quantity-input input[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    if (!variantId) return;

    window.upsellAction = 'checkout';

    // Reset selection list with the main product variant
    const mainItem = { id: parseInt(variantId), quantity: parseInt(quantity) || 1 };
    if (Object.keys(properties).length > 0) {
      mainItem.properties = properties;
    }

    window.selectedItems = [mainItem];

    // Reset modal button states
    modal.querySelectorAll('.celebration-upsell-add-btn').forEach(btn => {
      btn.classList.remove('added');
      btn.textContent = 'Add';
      btn.disabled = false;
    });

    // Instantly open the upsell modal popup!
    modal.classList.add('open');
  });

  // Tab switching
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.tab-nav-btn');
    if (!btn) return;

    const modal = document.getElementById('CelebrationUpsellModal');
    if (!modal) return;

    const tabButtons = modal.querySelectorAll('.tab-nav-btn');
    const tabPanels = modal.querySelectorAll('.tab-content-panel');

    tabButtons.forEach(b => b.classList.remove('active'));
    tabPanels.forEach(p => p.classList.remove('active'));

    btn.classList.add('active');
    const targetTab = btn.getAttribute('data-tab');
    const targetPanel = modal.querySelector(`#tab-${targetTab}`);
    if (targetPanel) targetPanel.classList.add('active');
  });

  // Toggle upsell items in memory (instantly, without network requests)
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.celebration-upsell-add-btn');
    if (!addBtn) return;

    const variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn("No variant ID found on addon button!");
      return;
    }

    if (!window.selectedItems || !Array.isArray(window.selectedItems)) {
      window.selectedItems = [];
    }

    const vId = parseInt(variantId);
    const index = window.selectedItems.findIndex(item => String(item.id) === String(variantId));

    if (index !== -1) {
      // Already selected, remove it
      window.selectedItems.splice(index, 1);
      addBtn.classList.remove('added');
      addBtn.textContent = 'Add';
    } else {
      // Not selected, add it
      window.selectedItems.push({ id: vId, quantity: 1 });
      addBtn.classList.add('added');
      addBtn.textContent = 'Added';
    }
  });

  // Close modal
  document.addEventListener('click', (e) => {
    if (e.target.closest('.celebration-upsell-modal__close-btn') || e.target.closest('.celebration-upsell-modal__backdrop')) {
      const modal = document.getElementById('CelebrationUpsellModal');
      if (modal) modal.classList.remove('open');
    }
  });

  // Continue to Cart / Checkout (batch-adds all selected items to cart)
  document.addEventListener('click', (e) => {
    const continueBtn = e.target.closest('.celebration-upsell-continue-btn');
    if (!continueBtn) return;

    const modal = document.getElementById('CelebrationUpsellModal');
    if (!modal) return;

    continueBtn.disabled = true;
    const originalText = continueBtn.textContent;

    // Clean and validate items payload for Shopify API
    const cleanItems = (window.selectedItems || [])
      .filter(item => item && item.id && !isNaN(parseInt(item.id)))
      .map(item => {
        const cleanObj = {
          id: parseInt(item.id),
          quantity: parseInt(item.quantity) || 1
        };
        if (item.properties && typeof item.properties === 'object') {
          const cleanProps = {};
          for (const [k, v] of Object.entries(item.properties)) {
            if (k && v !== undefined && v !== null && String(v).trim() !== '') {
              cleanProps[k] = String(v).trim();
            }
          }
          if (Object.keys(cleanProps).length > 0) {
            cleanObj.properties = cleanProps;
          }
        }
        return cleanObj;
      });

    if (cleanItems.length === 0) {
      alert('No valid items selected. Please try again.');
      continueBtn.disabled = false;
      continueBtn.textContent = originalText;
      return;
    }

    if (window.upsellAction === 'checkout') {
      continueBtn.textContent = 'Preparing checkout...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: cleanItems
        })
      })
      .then(async response => {
        const data = await response.json();
        if (!response.ok || data.status) {
          const errorMsg = data.description || data.message || 'Failed to add items to cart';
          throw new Error(errorMsg);
        }
        return data;
      })
      .then(data => {
        // Trigger header cart count updates
        updateCartBubbleCount();
        // Redirect directly to checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error proceeding to checkout:', error);
        alert(error.message || 'There was a problem proceeding to checkout. Please try again.');
        continueBtn.disabled = false;
        continueBtn.textContent = originalText;
      });
    } else {
      continueBtn.textContent = 'Adding to cart...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: cleanItems,
          sections: 'cart-drawer,cart-icon-bubble'
        })
      })
      .then(async response => {
        const data = await response.json();
        if (!response.ok || data.status) {
          const errorMsg = data.description || data.message || 'Failed to add items to cart';
          throw new Error(errorMsg);
        }
        return data;
      })
      .then(async data => {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');

        let sectionsData = data.sections;
        if (!sectionsData) {
          const sectionList = cartDrawer 
            ? cartDrawer.getSectionsToRender().map((section) => section.id) 
            : (cartNotification ? cartNotification.getSectionsToRender().map((section) => section.id) : []);

          if (sectionList.length > 0) {
            try {
              const sectionsRes = await fetch(`/?sections=${sectionList.join(',')}`);
              sectionsData = await sectionsRes.json();
            } catch (e) {
              console.error("Error fetching cart sections:", e);
            }
          }
        }

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.classList.remove('is-empty');
          const drawerItems = cartDrawer.querySelector('cart-drawer-items');
          if (drawerItems) drawerItems.classList.remove('is-empty');
          const drawerFooter = cartDrawer.querySelector('.drawer__footer');
          if (drawerFooter) drawerFooter.classList.remove('is-empty');

          if (sectionsData) {
            cartDrawer.renderContents({ sections: sectionsData });
          } else {
            updateCartBubbleCount();
            cartDrawer.open();
          }
        } else if (cartNotification) {
          if (sectionsData) {
            cartNotification.renderContents({ sections: sectionsData });
          } else {
            updateCartBubbleCount();
            cartNotification.open();
          }
        } else {
          updateCartBubbleCount();
        }

        updateCartBubbleCount();
        if (typeof updateCartDeliveryFee === 'function') {
          setTimeout(updateCartDeliveryFee, 300);
        }

        modal.classList.remove('open');
        continueBtn.disabled = false;
        continueBtn.textContent = originalText;
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert(error.message || 'There was a problem adding to cart. Please try again.');
        continueBtn.disabled = false;
        continueBtn.textContent = originalText;
      });
    }
  });

  // Function to dynamically update header cart counts
  function updateCartBubbleCount() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const bubbleSpans = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble span[aria-hidden="true"]');
      bubbleSpans.forEach(span => {
        span.textContent = cart.item_count;
      });
      // Handle visibility of bubble
      const bubbles = document.querySelectorAll('.cart-count-bubble, #cart-icon-bubble');
      bubbles.forEach(bubble => {
        if (cart.item_count > 0) {
          bubble.classList.remove('hidden');
        } else {
          bubble.classList.add('hidden');
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCelebrationUpsell);
} else {
  initCelebrationUpsell();
}
